import { render, staticRenderFns } from "./customer-header-routing.vue?vue&type=template&id=07084c3c"
import script from "./customer-header-routing.vue?vue&type=script&lang=js"
export * from "./customer-header-routing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports